import PropTypes from 'prop-types';

const interactiveServiceShape = PropTypes.shape({
  isRegistered: PropTypes.func,
  register: PropTypes.func,
  createInteractive: PropTypes.func,
  getInteractive: PropTypes.func,
  deleteInteractive: PropTypes.func,
  moveInteractiveComponents: PropTypes.func,
});

export default interactiveServiceShape;
